import React, { useEffect, useRef } from 'react';
import '../css/Benefits.css';
import carIcon from '../images/new-car-transparent.png';
import kabaaIcon from '../images/makka-kabaa-transparent.png';
import travelIcon from '../images/traveling-transparent.png';
import savingsIcon from '../images/euro-savings-bag-transparent.png';
import houseIcon from '../images/house-renovation-transparent.png';

const Benefits = () => {
  const benefitsRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          benefitsRef.current.classList.add('show-benefits');
        }
      },
      { threshold: 0.2 } // Trigger when 20% of the section is visible
    );

    observer.observe(benefitsRef.current);

    return () => {
      if (benefitsRef.current) {
        observer.unobserve(benefitsRef.current);
      }
    };
  }, []);

  const benefits = [
    { id: 1, icon: carIcon, label: 'Nieuwe Auto' },
    { id: 2, icon: kabaaIcon, label: 'Oumrah' },
    { id: 3, icon: travelIcon, label: 'Reizen' },
    { id: 4, icon: houseIcon, label: 'Huis Renovatie' },
    { id: 5, icon: savingsIcon, label: 'Of gewoon: Sparen' },
  ];

  return (
    <div className="benefits-container" ref={benefitsRef}>
      <h2>Met de Rosca App Samen Sparen Voor</h2>
      <div className="benefits-grid">
        {benefits.map((benefit, index) => (
          <div key={benefit.id} className={`benefit-box ${index % 2 === 0 ? 'odd' : 'even'}`}>
            <img src={benefit.icon} alt={benefit.label} className="benefit-icon" />
            <p>{benefit.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
